export function maskStringData(data) {
    if (!data || typeof data !== 'string') {
        return null; 
    }

    // var chineseRegex = /^[\u4e00-\u9fa5]+$/;

    var pieces = data.trim().split(/\s+/);

    if (pieces.length === 1) {
        var word = pieces[0];
        if(word.length == 1) {
          return "*";
        }
        else if (word.length < 4) {
            return word[0] + "*".repeat(Math.max(word.length - 1, 0));
        } else {
            return word.slice(0, 3) + "*".repeat(Math.max(word.length - 3, 0));
        }
    } else {
        var title = pieces[0].includes('.') ? pieces[0] : pieces[0].length < 3 ? pieces[0].slice(0, 1) + "*".repeat(Math.max(pieces[0].length - 1, 0)) : pieces[0].slice(0, 3) + "*".repeat(Math.max(pieces[0].length - 3, 0));
        var name = pieces.slice(1).map(function(s) {
            if (s.length < 3) {
                return s.slice(0, 1) + "*".repeat(Math.max(s.length - 1, 0));
            } else {
                return s.slice(0, 3) + "*".repeat(Math.max(s.length - 3, 0));
            }
        }).join(' ');

        return title + ' ' + name;
    }
}

export function maskPhoneData(phoneNumber) {
if(phoneNumber == null || phoneNumber == "") return null;

let num = phoneNumber.match(/\d/g);

if (!num) {
  return phoneNumber;
}

for (let i = 3; i < num.length; i++) {
  num[i] = '*';
}

return num.join('');
}